import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import DocumentNavigation from 'components/DocumentNavigation/DocumentNavigation';
import DocumentsSubHeader from 'components/DocumentsSubHeader';
import GeneralMUITableWrapper from 'components/GeneralMUITableWrapper';
import { documentNavigationConfig } from 'constants/documentsNavigation';
import { COLLECTION_EXECUTED_TYPE, COLLECTION_TYPE } from 'constants/general';
import ROUTES from 'constants/routes';
import { RootStateType } from 'store/reducers';
import { DocumentStatusType } from 'types/Documents';
import { ListingViewsTabs, TableRowsType } from 'types/Mui';
import { createTableData } from 'utils/dataColumns';

const Collections = () => {
  const { collections, collectionsExecuted } = useSelector((state: RootStateType) => state.user);
  const [collectionsRows, setCollectionsRows] = useState<TableRowsType>([]);
  const [activeStatuses, setActiveStatuses] = useState<DocumentStatusType>(documentNavigationConfig[0].statuses);
  const isExecutedPage = activeStatuses.length > 0;

  useEffect(() => {
    if (isExecutedPage) {
      setCollectionsRows(createTableData(collectionsExecuted, COLLECTION_EXECUTED_TYPE, activeStatuses));
    } else {
      setCollectionsRows(createTableData(collections, '', [], COLLECTION_TYPE));
    }
  }, [collections, collectionsExecuted, activeStatuses]);

  return (
    <>
      <DocumentsSubHeader
        title="Collections"
        buttonText="Create new collection"
        buttonLink={ROUTES.COLLECTIONS_EDITOR}
      />
      <DocumentNavigation
        activeTab={activeStatuses}
        setActiveTab={setActiveStatuses}
      />
      <div className="w-75 mx-auto pb-5">
        <GeneralMUITableWrapper
          tableRows={collectionsRows}
          isAllDocumentsTab={!isExecutedPage}
          currentTableTab={isExecutedPage ? ListingViewsTabs.COLLECTIONS_EXECUTED : ListingViewsTabs.COLLECTIONS}
          setActiveTab={setActiveStatuses}
          activeStatuses={activeStatuses}
        />
      </div>
    </>
  );
};

export default Collections;